import { User } from '@auth0/auth0-react';
import { create } from 'zustand';

export type UserStateWithMetadata = User & Record<string, any>;
export const useUserStateStore = create<UserStateWithMetadata>((set) => ({
  user: {},
  setUser: (user: UserStateWithMetadata) => set((state) => ({ user: { ...user, ...state.user } })),
}));
